<template>
  <div class="case-editors">
    
    <InputGroup
      title="Set Case Editors/Supporting Surgeons"
      desc="Select other users who can view and edit this case. Use the search box to filter users by name."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      >
      <MultiSelect
        :options="editors"
        v-model="caseForm.editors"
        />      
    </InputGroup>


    <InputGroup
      title=""
      desc=""
      :skipWhiteBox="true"
      :noLine="true"
      :condensed="true"
      :oneColumn="true"
      :fixedToBottom="true"
      >
      <Button
        label="Save"
        color="green"
        size="large"
        icon="save" 
        @click="submitCaseEditors"
        />
    </InputGroup>


  </div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"

export default {
  props: [
    'thisCase',
		'editors'
  ],
  components: {
    InputGroup,
    Button,
    MultiSelect
  },
  data: () => {
    return {
      caseForm: {
        editors: []
      },
    }
  },
  mounted(){
    this.caseForm.editors = this.thisCase.editors.map(viewer => viewer.id) // load in existing values
  },
  methods: {
    submitCaseEditors(){
			this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/editors`, this.caseForm)
    },
  }
}

</script>

<style scoped lang="sass">

.case-editors
	select[multiple]
		width: 100%
		min-height: 200px



</style>